import React from "react"
import {Link} from 'react-router-dom'

const Show=({route})=> {
    

    return (
      <>
      <Link to={route}> <i style={{color:'#f7931a'}} className="fas fa-eye"></i></Link>
      </>
    )
  }

export default Show;